import { Injectable } from '@angular/core';
import { IBoondockRating, ICaretaker, IGuestRating, IListingRating, IPoiRating } from '@curbnturf/entities';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as RatingActions from './rating.actions';
import { RatingState } from './rating.reducer';
import { ratingQuery } from './rating.selectors';

@Injectable({
  providedIn: 'root',
})
export class RatingFacade {
  listingRatings$: Observable<IListingRating[]>;
  guestRatings$: Observable<IGuestRating[]>;
  boondockRatings$: Observable<IBoondockRating[]>;
  poiRatings$: Observable<IPoiRating[]>;
  caretakerSites$: Observable<number[]>;

  constructor(private store: Store<RatingState>) {
    this.listingRatings$ = this.store.pipe(select(ratingQuery.getAllListingRatings));
    this.guestRatings$ = this.store.pipe(select(ratingQuery.getAllGuestRatings));
    this.boondockRatings$ = this.store.pipe(select(ratingQuery.getAllBoondockRatings));
    this.poiRatings$ = this.store.pipe(select(ratingQuery.getAllPoiRatings));
    this.caretakerSites$ = this.store.pipe(select(ratingQuery.getCaretakerSites));
  }

  loadGuest(guestId: number) {
    this.store.dispatch(RatingActions.loadGuestRatings({ guestId }));
  }

  loadListing(listingId: number) {
    this.store.dispatch(RatingActions.loadListingRatings({ listingId }));
  }

  loadBoondock(boondockId: number) {
    this.store.dispatch(RatingActions.loadBoondockRatings({ boondockId }));
  }

  loadPoi(poiId: number) {
    this.store.dispatch(RatingActions.loadPoiRatings({ poiId }));
  }

  createListing(ratings: IListingRating[]) {
    this.store.dispatch(RatingActions.createListingRatings({ ratings }));
  }

  createGuest(ratings: IGuestRating[]) {
    this.store.dispatch(RatingActions.createGuestRatings({ ratings }));
  }

  createBoondock(ratings: IBoondockRating[]) {
    this.store.dispatch(RatingActions.createBoondockRatings({ ratings }));
  }

  createPoi(ratings: IPoiRating[]) {
    this.store.dispatch(RatingActions.createPoiRatings({ ratings }));
  }

  selectCaretakerBoondock(caretakerRequest: ICaretaker) {
    this.store.dispatch(RatingActions.selectCaretakerBoondock({ caretaker: caretakerRequest }));
  }
}
